<template>
    <div>
        <div v-if="cards">
            <draggable v-model="cards" :options="{draggable: '.list-group-item'}"
                    class="list-group mt-4" @end="saveOrder">
                <router-link v-for="card in cards"
                            :to="{name: 'synthesis-card-edit', params: { cardId: card.id}}"
                            class="list-group-item list-group-item-action dd-flex align-items-center"
                            :key="card.id">
                    {{card.name.text}}
                    <a href="#" class="ml-auto" v-confirm="{
                                html: true,
                                ok: dialog => remove(dialog, card),
                                message: 'Bist du sicher, dass du die Karteikarte <strong>'+card.name.text+'</strong> löschen möchtest?'}"><i
                            class="fa fa-trash fa-fw"></i></a>
                </router-link>
            </draggable>

            <hr>
            <a href="#" class="btn btn-success" style="margin-top: auto;"
              @click.prevent="showCreateModal = true">Hinzufügen</a>

            <b-modal ref="modal" v-model="showCreateModal" @ok="add">
                <h1 slot="modal-title">Karteikarte hinzufügen</h1>
                <div class="form-group">
                    <label for="name">Name</label>
                    <input type="text" id="name" v-model="cardName" class="form-control">
                </div>
                <div class="form-group">
                    <label for="#card-size">Grösse</label>
                    <multiselect id="card-size" v-model="cardSize"
                                :options="[1, 2]"
                                :show-labels="false">
                    </multiselect>
                </div>
            </b-modal> 
        </div>
        <loading v-else></loading>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
export default {
  components: { Multiselect },
  props: {
    data: Object,
    isSubchapter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showCreateModal: false,
      cards: this.data.cards,
      cardSize: 1,
      cardName: ''
    };
  },
  watch: {
    data(newData) {
      this.cards = newData.cards;
    }
  },
  methods: {
    add() {
      let form = new FormData();
      form.append("edit_card[name]", this.cardName);
      form.append("edit_card[size]", this.cardSize-1);
      form.append("edit_card[subChapter]", this.isSubchapter ? this.data.id : '');
      form.set("edit_card[submit]", null);
      axios
        .post("/api/" + store.state.language + "/card/create", form)
        .then(({ data }) => {
          this.cards.push(data.result);
          this.cardName = "";
          this.cardSize = 1;
          this.$emit("cardsChange", this.cards)
        });
    },
    remove(dialog, card) {
      axios
        .post(
          "/api/" +
            store.state.language +
            "/card/" +
            card.id +
            "/delete"
        )
        .then(({ data }) => {
          if (data.success) {
            this.cards.splice(this.cards.indexOf(card), 1);
          }
        });
    },
    saveOrder() {
      const cardIds = this.cards.map(card => card.id);
      store.commit("addSavingProcess");
      axios
        .post("/api/" + store.state.language + "/card/set_card_order", {
          ids: cardIds
        })
        .then(({ data }) => {
          store.commit("finishSavingProcess");
        })
        .catch(err => {
          store.commit("finishSavingProcess");
          alert(
            "Beim Speichern der Sortier-Reihenfolge ist ein Fehler aufgetreten."
          );
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/synthesis/card/List.vue